import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PropTypes from "prop-types";
import { formatearFecha, porcentaje, metricasPropTypes, COLOR_EAD, COLOR_RAD } from "./efectividadUtils.js";

/**
 * Barras por sucursal de UN dia del historial: EAD (entregas a tiempo) y Recolecciones
 * realizadas, en %. Solo se pintan las sucursales con actividad (las que quedaron en NULL
 * no aparecen). Las lineas punteadas marcan el global ponderado del dia para comparar.
 * El tooltip muestra el numerador y el denominador de cada indicador.
 */
function GraficaEfectividadSucursales(props) {
  const filas = (props.sucursales || []).filter(
    (s) => s.ead_total !== null || s.rec_total !== null
  );
  const global = props.global || {};

  if (filas.length === 0) {
    return (
      <p style={{ textAlign: "center", color: "#999", padding: 24 }}>
        Sin datos de efectividad para {props.fecha ? "el " + formatearFecha(props.fecha) : "ese día"}.
      </p>
    );
  }

  const plotLines = [];
  if (global.ead !== null && global.ead !== undefined) {
    plotLines.push({
      value: global.ead, color: COLOR_EAD, dashStyle: "ShortDash", width: 2, zIndex: 5,
      label: { text: "Global EAD " + porcentaje(global.ead), align: "right", style: { color: COLOR_EAD, fontSize: "11px" } }
    });
  }
  if (global.rad !== null && global.rad !== undefined) {
    plotLines.push({
      value: global.rad, color: COLOR_RAD, dashStyle: "ShortDash", width: 2, zIndex: 5,
      label: { text: "Global recolecciones " + porcentaje(global.rad), align: "right", style: { color: COLOR_RAD, fontSize: "11px" } }
    });
  }

  const options = {
    chart: { type: "column", height: 430 },
    title: { text: "Efectividad por sucursal" },
    subtitle: {
      text: "Datos del " + formatearFecha(props.fecha) + " · " + filas.length + " sucursales con actividad"
    },
    xAxis: {
      categories: filas.map((s) => s.prefijo),
      crosshair: true,
      labels: { rotation: -45, style: { fontSize: "11px" } }
    },
    yAxis: { min: 0, max: 100, title: { text: "Efectividad %" }, plotLines: plotLines },
    legend: { enabled: true },
    credits: { enabled: false },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const s = filas[this.points[0].point.index];
        if (!s) {
          return false;
        }
        let html = "<b>" + s.prefijo + " - " + s.nombre + "</b><br/>";
        html += '<span style="color:' + COLOR_EAD + '">&#9679;</span> EAD: <b>' + porcentaje(s.ead) + "</b>";
        html += s.ead_total !== null
          ? " (" + s.ead_atiempo + " a tiempo de " + s.ead_total + " guías)<br/>"
          : " (sin guías ese día)<br/>";
        html += '<span style="color:' + COLOR_RAD + '">&#9679;</span> Recolecciones: <b>' + porcentaje(s.rad) + "</b>";
        html += s.rec_total !== null
          ? " (" + s.rec_realizadas + " realizadas de " + s.rec_total + ")"
          : " (sin recolecciones ese día)";
        return html;
      }
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        groupPadding: 0.1,
        dataLabels: { enabled: true, format: "{point.y:.0f}", style: { fontSize: "9px", fontWeight: "normal" } }
      }
    },
    series: [
      { name: "EAD (entregas a tiempo)", color: COLOR_EAD, data: filas.map((s) => s.ead) },
      { name: "Recolecciones realizadas", color: COLOR_RAD, data: filas.map((s) => s.rad) }
    ]
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}

GraficaEfectividadSucursales.propTypes = {
  fecha: PropTypes.string,
  global: PropTypes.shape(metricasPropTypes),
  sucursales: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      prefijo: PropTypes.string,
      nombre: PropTypes.string,
      ...metricasPropTypes
    })
  )
};

export default GraficaEfectividadSucursales;
